// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueWaypoint from 'vue-waypoint'
import MomentPlugin from './plugins/moment'
import AxiosPlugin from './plugins/axios'

Vue.use(VueWaypoint)
Vue.use(MomentPlugin)
Vue.use(AxiosPlugin)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js